<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="用户">
								<a-input v-model="queryParams.user" placeholder="ID/账号" allow-clear />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="科目">
								<a-select v-model="queryParams.subject" placeholder="全部" allowClear>
									<a-select-option :value="1">上分</a-select-option>
									<a-select-option :value="2">下分</a-select-option>
									<a-select-option :value="3">投注</a-select-option>
									<a-select-option :value="4">中奖</a-select-option>
									<a-select-option :value="5">还分</a-select-option>
								</a-select>
							</a-form-item>
						</a-col>
						<a-col :span="6">
							<span class="x-filter-submit-box">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left: 8px" @click="() => this.queryParams={}">重置</a-button>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<a-table
				:rowKey="record => record.id"
				:columns="tableColumns"
				:loading="tableLoading"
				:dataSource="tableData"
				:pagination="false"
			>
                <div slot="user" slot-scope="record">
                    <span>{{ record.userLoginAccount }}</span>
                    -
                    <span>{{ record.userNickname }}</span>
                </div>

                <template slot="subject" slot-scope="record">
                    <span v-if="record.subject == 1">上分</span>
                    <span v-else-if="record.subject == 2">下分</span>
                    <span v-else-if="record.subject == 3">投注</span>
                    <span v-else-if="record.subject == 4">中奖</span>
                    <span v-else-if="record.subject == 5">还分</span>
                </template>

				<template slot="changeAmount" slot-scope="record">
					<span :class="record.amount >= 0 ? 'amount-up' : 'amount-down'">{{ record.amount }}</span>
				</template>
			</a-table>

			<div class="x-pagination">
				<a-pagination
					:pageSize="pageSize"
					v-model="pageIndex"
					:total="totalRow"
					@change="pageChange"
					:hideOnSinglePage="true"
					show-less-items
				/>
			</div>
		</a-card>
	</div>
</template>

<script>
import { userAccountList } from '@/api/member/account';

const tableColumns = [
	{ title: '#', dataIndex: 'id' },
	{ title: '用户', scopedSlots: { customRender: 'user' } },
	{ title: '科目', scopedSlots: { customRender: 'subject' } },
	{ title: '变动金额', scopedSlots: { customRender: 'changeAmount' } },
	{ title: '变动后余额', dataIndex: 'afterAmount' },
	{ title: '创建时间', dataIndex: 'created' },
];

export default {
	data() {
		return {
			queryParams: {},
			tableLoading: false,
			tableColumns,
			tableData: [],
			totalRow: 0,
			pageSize: 20,
			pageIndex: 1,
		};
	},
	created() {
		this.getTableData();
	},
	methods: {
        getTableData() {
			this.tableLoading = true;
			const params = {
				...this.queryParams,
				pageSize: this.pageSize,
				page: this.pageIndex,
			};
			return userAccountList(params).then((res) => {
				this.tableData = res.data.recordList || [];
				this.totalRow = res.data.totalRow || 0;
			}).finally(() => {
				this.tableLoading = false;
			});
		},
		pageChange(current) {
			this.pageIndex = current;
			this.getTableData();
		},
	},
};
</script>

<style lang="less" scoped>
.amount-up {
	color: #52c41a;
}

.amount-down {
	color: #ff4d4f;
}
</style>
